export const USER_VERIFICATION_JOB_START_TIME = {
  FEW_MONTHS: {
    displayValue: "I'm available in a few months",
    key: 'FEW_MONTHS',
  },
  FEW_WEEKS: {
    displayValue: "I'm available in a few weeks",
    key: 'FEW_WEEKS',
  },
  HALF_YEAR: {
    displayValue: "I'm available in half a year",
    key: 'HALF_YEAR',
  },
  IMMEDIATELY: {
    displayValue: "I'm available immediately",
    key: 'IMMEDIATELY',
  },
  NOT_SURE: {
    displayValue: 'Not yet sure when available',
    key: 'NOT_SURE',
  },
  ONE_MONTH: {
    displayValue: "I'm available in a month",
    key: 'ONE_MONTH',
  },
};

export const NEW_VERIFIED_USER_BATCH_PUBLISHING_HOUR_OF_DAY = 5;
